var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.79346,
    cy: 10.2535,
    r: 9.53476,
    fill: "#A1A1A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 7.66502L4.92092 8.07744L4.5085 7.66502L4.92092 7.2526L5.33333 7.66502ZM8.25 14.665C8.09529 14.665 7.94692 14.6036 7.83752 14.4942C7.72812 14.3848 7.66667 14.2364 7.66667 14.0817C7.66667 13.927 7.72812 13.7786 7.83752 13.6692C7.94692 13.5598 8.09529 13.4984 8.25 13.4984V14.665ZM7.83758 10.9941L4.92092 8.07744L5.74575 7.2526L8.66242 10.1693L7.83758 10.9941ZM4.92092 7.2526L7.83758 4.33594L8.66242 5.16077L5.74575 8.07744L4.92092 7.2526ZM5.33333 7.08169H11.4583V8.24835H5.33333V7.08169ZM11.4583 14.665H8.25V13.4984H11.4583V14.665ZM15.25 10.8734C15.25 11.879 14.8505 12.8434 14.1394 13.5545C13.4284 14.2655 12.4639 14.665 11.4583 14.665V13.4984C11.8031 13.4984 12.1444 13.4305 12.4629 13.2985C12.7814 13.1666 13.0707 12.9733 13.3145 12.7295C13.5582 12.4858 13.7516 12.1964 13.8835 11.8779C14.0154 11.5594 14.0833 11.2181 14.0833 10.8734H15.25ZM11.4583 7.08169C12.4639 7.08169 13.4284 7.48117 14.1394 8.19224C14.8505 8.90332 15.25 9.86774 15.25 10.8734H14.0833C14.0833 10.5286 14.0154 10.1873 13.8835 9.86881C13.7516 9.55033 13.5582 9.26095 13.3145 9.0172C13.0707 8.77345 12.7814 8.58009 12.4629 8.44817C12.1444 8.31625 11.8031 8.24835 11.4583 8.24835V7.08169Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnTick);
export default __webpack_public_path__ + "static/media/return_tick.469fc8112b57b6a2e90f414d74924ede.svg";
export { ForwardRef as ReactComponent };